export const landingEs = {
  landing: {
    heroTitle: "De datos satelitales a informes de parcela defendibles.",
    heroSubtitle: "Sentinel Crop combina monitorización Sentinel-2, modelado FAO-56 de demanda hídrica y verificaciones de disponibilidad de datos en informes de parcela transparentes.",
    getStarted: "Comenzar",
    learnMore: "Saber Más",
    features: "Características",
    pricing: "Precios",
    contact: "Contacto",
    trustedBy: "Datos satelitales y meteorológicos oficiales",
    feature1Title: "Monitoreo Satelital",
    feature1Desc: "Índices de vegetación en tiempo real desde satélites Sentinel-2",
    feature2Title: "Insights con IA",
    feature2Desc: "Predicciones de machine learning para salud y rendimiento del cultivo",
    feature3Title: "Riego Inteligente",
    feature3Desc: "Optimización de gestión del agua basada en FAO-56",
    feature4Title: "Protección contra Heladas",
    feature4Desc: "Predicción avanzada con alertas SMS",
    ctaTitle: "¿Listo para optimizar tu granja?",
    ctaButton: "Explorar la plataforma"
  },
  hero: {
    eyebrow: "Plataforma de evidencia y reporting por parcela",
    title: "Agente de Operaciones Agrícolas para agricultura a gran escala.",
    subtitle: "Prioriza el riego, detecta riesgos del cultivo, planifica tareas de campo y verifica decisiones por parcela a partir de datos de satélite, clima y campo.",
    secondary: "Estrés hídrico. Riesgo de plagas. Tareas de campo. Informes verificados.",
    overlayIrrigationPriority: "Prioridad de riego",
    overlayWaterStress: "Riesgo de estrés hídrico",
    overlayFieldTask: "Tarea de campo generada",
    overlayVerifiedReport: "Informe verificado",
    satelliteMonitoring: "Monitoreo Satelital",
    satelliteMonitoringDesc: "Monitoreo real NDVI de salud del cultivo desde el espacio",
    frostProtection: "Protección Heladas",
    frostProtectionDesc: "Alertas tempranas de heladas 2-3 días antes",
    smartIrrigation: "Riego Inteligente",
    smartIrrigationDesc: "Optimización de agua validada FAO-56",
    startFreeTrial: "Ver informe de ejemplo",
    viewSampleReport: "Ver informe de ejemplo",
    bookDemo: "Reservar demo",
    talkToSales: "Reservar demo",
    faoBadge: "Benchmarked",
    chipEvidence: "Trazabilidad de evidencia",
    chipSentinel: "Imágenes Sentinel-2",
    chipFao: "Modelo FAO-56 de demanda hídrica",
    chipReadiness: "Verificación de datos"
  },
  featuresSection: {
    badge: "Capacidades",
    title: "Todo lo necesario para generar un informe de campo defendible.",
    subtitle: "Sentinel Crop transforma datos satelitales, meteorológicos y de campo en decisiones agronómicas y reportes defendibles por parcela.",
    healthyVineyard: "Viñedo Saludable",
    waterStressDetected: "Estrés Hídrico Detectado",
    realTimeMonitoring: "Comparación de evidencia por parcela",
    dragSlider: "Arrastra el deslizador para ver cómo el monitoreo satelital detecta estrés antes de que aparezcan síntomas visibles",
    advancedProtection: "Capa de Evidencia y Reporting",
    howWeMonitor: "De datos satelitales a informes de campo defendibles",
    howWeMonitorDesc: "Cada capacidad alimenta una única traza de evidencia auditable por parcela — base de los Field Intelligence Reports para cooperativas, productores y aseguradoras.",
    satelliteCropMonitoring: "Evidencia por Parcela",
    satelliteCropMonitoringDesc: "NDVI / NDWI / NDRE de Sentinel-2 por parcela, con timestamp y auditables — la capa objetiva detrás de cada informe.",
    satelliteDetails: ["Imágenes Sentinel-2 cada 3–5 días", "Histórico NDVI / NDWI / NDRE por parcela", "Filtrado de nubes e indicadores de calidad", "Traza de evidencia con hash SHA-256 (tamper-evident)"],
    frostProtectionAlerts: "Alertas de Riesgo de Cartera",
    frostProtectionAlertsDesc: "Heladas, sequía, estrés hídrico y anomalías sobre toda la cartera de parcelas — pensado para técnicos de cooperativa y operaciones de aseguradoras.",
    frostDetails: ["Pronóstico de helada 2–3 días", "Indicadores de sequía y estrés hídrico", "Detección de anomalías entre parcelas", "Entrega vía API + email/SMS"],
    smartIrrigation: "Demanda Hídrica FAO-56",
    smartIrrigationDesc: "ET₀ por Penman-Monteith y balance hídrico Dual Kc por parcela. Metodología estándar, entradas transparentes, salidas defendibles.",
    irrigationDetails: ["ET₀ FAO-56 Penman-Monteith", "Balance hídrico Dual Kc", "Comparado con datasets ET₀ de referencia", "Entradas y supuestos completamente expuestos"],
    digitalFieldNotebook: "Trazabilidad de Intervenciones",
    digitalFieldNotebookDesc: "Cada riego, tratamiento y fertilización vinculado a su parcela y a la evidencia satelital de la misma fecha.",
    fieldNotebookDetails: ["Vínculo bidireccional con prescripciones", "Operador y timestamp registrados", "Contraste con la serie NDVI", "Exportable para auditorías y revisiones de cumplimiento"],
    fertilizationPlanning: "Evidencia de Planificación de Nutrientes",
    fertilizationPlanningDesc: "Planes VRA de nitrógeno, P y K a partir de zonas NDVI/NDRE y datos de suelo — con los datos subyacentes asociados a cada recomendación.",
    fertilizationDetails: ["Zonas K-Means sub-parcelarias a 10 m", "Índices de suficiencia N / P / K", "Exportación shapefile / CSV a maquinaria", "Metodología y entradas declaradas"],
    professionalReports: "Informes de Campo Defendibles",
    professionalReportsDesc: "Field Intelligence Reports que consolidan datos satelitales, FAO-56 e intervenciones en un PDF por parcela, con timestamp y hash.",
    reportsDetails: ["Un informe por parcela y periodo", "Fuentes, métodos y supuestos listados", "ID documental SHA-256 con verificación pública de metadata no sensible", "EN / ES, listos para cooperativas y aseguradoras"]
  },
  pricingSection: {
    badge: "Precios Transparentes",
    title: "Planes para operaciones basadas en evidencia",
    subtitle: "Field Intelligence Reports, evidencia a nivel de parcela, modelado FAO-56 de demanda hídrica, monitorización de cartera y acceso API / white-label — diseñado para cooperativas, aseguradoras, agroindustria y productores de 200+ ha.",
    monthly: "Mensual",
    annual: "Anual",
    save20: "💰 Ahorra 20%",
    mostPopular: "⭐ Opción Más Popular",
    hectares: "Hectáreas:",
    costPerHa: "Coste por ha:",
    startFreeTrial: "Explorar la plataforma",
    requestAccess: "Empezar prueba de 7 días",
    talkToSales: "Hablar con Ventas",
    requestApiDemo: "Solicitar Demo API",
    freeTrial: "🎁 Plan gratuito disponible",
    trialBadge: "",
    noCreditCard: "No requiere tarjeta de crédito",
    viewCompleteFeatures: "📋 Ver Lista Completa de Características",
    allPricesExclude: "Todos los precios excluyen IVA. Los planes anuales ofrecen 8.3% de ahorro. Soluciones Enterprise disponibles bajo solicitud.",
    highResAvailable: "Imágenes satelitales de alta resolución disponibles bajo demanda para análisis detallado de parcelas",
    freeTierLink: "¿Solo explorando? Accede al plan gratuito →",
    plans: {
      producer: {
        name: "Productor",
        subtitle: "Para productores técnicos y explotaciones de hasta 250 ha",
        description: "Para productores técnicos y explotaciones medianas/grandes (hasta 250 ha) que necesitan evidencia a nivel de parcela y modelado FAO-56 de demanda hídrica consolidados en Field Intelligence Reports.",
        priceNote: "EUR/mes, facturación anual"
      },
      cooperative: {
        name: "Cooperativa",
        subtitle: "50–500 socios bajo un mismo panel",
        description: "Flujo de cooperativa: monitorización de cartera entre todos los socios, benchmarking anónimo y Field Intelligence Reports por parcela para auditorías de subvenciones, trazabilidad y sostenibilidad.",
        priceLabel: "A medida",
        priceNote: "Precio por volumen"
      },
      enterprise: {
        name: "Enterprise",
        subtitle: "Aseguradoras · Trading · Agroindustria",
        description: "Flujo de aseguradoras y agroindustria: monitorización de riesgo de cartera, evidencia a nivel de parcela y Field Intelligence Reports entregados vía REST API y white-label, integrados en tus sistemas core.",
        priceLabel: "A medida",
        priceNote: "Acceso API · SLA"
      }
    },
    contactForm: {
      cooperativeTitle: "Hablar con ventas — Cooperativa",
      cooperativeSubtitle: "Cuéntanos sobre tu cooperativa. Te respondemos en menos de 24 horas hábiles.",
      enterpriseTitle: "Solicitar demo Enterprise / API",
      enterpriseSubtitle: "¿Aseguradora, agroindustria o trading? Te contactamos en menos de 24 horas hábiles.",
      name: "Nombre completo",
      organization: "Organización",
      email: "Email corporativo",
      phone: "Teléfono (opcional)",
      membersOrHectares: "Número de socios / hectáreas",
      useCase: "Caso de uso",
      useCaseInsurance: "Seguros",
      useCaseCooperative: "Cooperativa",
      useCaseAgribusiness: "Agroindustria / Trading",
      useCaseOther: "Otro",
      submit: "Enviar solicitud",
      submitting: "Enviando…",
      successTitle: "Gracias",
      successMessage: "Te contactaremos en menos de 24 horas hábiles.",
      errorTitle: "No se pudo enviar",
      errorMessage: "Inténtalo de nuevo o escribe directamente a hello@sentinelcrop.com.",
      requiredFields: "Por favor completa todos los campos obligatorios con un email válido."
    },
    traceabilityFeature: "ID documental SHA-256 con verificación pública de metadata no sensible",
    traceabilityDetailed: "ID documental SHA-256 con verificación pública de metadata no sensible. El anclaje público opcional aplica solo a certificados seleccionados."
  },
  footerSection: {
    platform: "Plataforma",
    pricing: "Precios",
    sampleReport: "Informe de muestra",
    resources: "Recursos",
    dataSources: "Fuentes de datos",
    standardsMethodologies: "Estándares y metodologías",
    support: "Soporte",
    helpCenter: "Centro de ayuda",
    contactUs: "Contacto",
    bookDemo: "Reservar demo",
    login: "Iniciar sesión",
    companyDesc: "Sentinel Crop es el Agente de Operaciones Agrícolas para agricultura a gran escala — una capa agronómica autónoma que revisa cada señal de la parcela, marca la evidencia faltante y convierte los datos validados en decisiones operativas.",
    globalSupport: "Soporte Global 24/7",
    compliance: "Cumplimiento",
    regulatoryReadiness: "Preparación Regulatoria",
    privacy: "Privacidad",
    terms: "Términos",
    copyright: "© 2026 Sentinel Crop. Todos los derechos reservados.",
    cookies: "Cookies",
    legalNotice: "Aviso Legal",
    regionsLine: "🌍 Europa • 🌎 Latinoamérica • 🌏 Cobertura mundial"
  },
  coreStrengths: {
    badge: "Tecnología Central",
    title: "Tres capas. Un informe por parcela.",
    subtitle: "Estado del cultivo, demanda hídrica y disponibilidad de datos — combinados por parcela.",
    satelliteTitle: "Estado del cultivo",
    satelliteDesc: "Las imágenes Sentinel-2 ayudan a seguir el estado de la vegetación, tendencias NDVI y cambios por parcela.",
    satelliteHighlights: ["NDVI / NDWI por parcela", "Actualización cada pocos días"],
    weatherTitle: "Demanda hídrica",
    weatherDesc: "FAO-56 estima ET₀, Kc y ETc para apoyar las decisiones de riego.",
    weatherHighlights: ["FAO-56 Penman-Monteith", "Dual Kc por etapa del cultivo"],
    algorithmsTitle: "Disponibilidad de datos",
    algorithmsDesc: "El informe muestra qué datos existen, qué falta y qué acciones se recomiendan.",
    algorithmsHighlights: ["Limitaciones declaradas", "Acciones siguientes recomendadas"]
  },
  workflow: {
    badge: "Flujo de producto",
    title: "Monitorizar → Decidir → Reportar → Demostrar",
    subtitle: "Un flujo que convierte datos satelitales, meteorológicos y de campo en decisiones por parcela y reportes defendibles.",
    steps: {
      monitor: {
        title: "Monitorizar",
        desc: "Comprende qué está ocurriendo en cada parcela usando satélite, clima, alertas y observaciones de campo."
      },
      decide: {
        title: "Decidir",
        desc: "Convierte señales agronómicas en decisiones de riego, fertilización, scouting y apoyo a tratamiento."
      },
      report: {
        title: "Reportar",
        desc: "Genera informes por parcela que explican disponibilidad de datos, recomendaciones y limitaciones."
      },
      prove: {
        title: "Demostrar",
        desc: "Conserva evidencia defendible con timestamps satelitales, registros de campo y trazabilidad documental con SHA-256."
      }
    }
  },
  sampleReport: {
    badge: "Ejemplo de salida",
    title: "Informe de Inteligencia de Campo de ejemplo",
    subtitle: "Cómo se ve un informe de Sentinel Crop para una parcela — combinando estado satelital, demanda hídrica y disponibilidad de datos declarada.",
    parcelTitle: "Resumen de parcela",
    parcelLine1: "Finca La Conchuela · Olivar · 12,4 ha",
    parcelLine2: "Coords 37,85°N, -4,78°W · Período: últimos 90 días",
    ndviTitle: "Resumen NDVI",
    ndviLine1: "NDVI medio 0,62 · 12 adquisiciones Sentinel-2 sin nubes",
    ndviLine2: "Vigor estable, leve estrés en la sub-zona noreste",
    faoTitle: "Demanda hídrica FAO-56",
    faoLine1: "ET₀ 4,8 mm/día · Kc 0,65 · ETc 3,1 mm/día",
    faoLine2: "Necesidad de riego semanal estimada: 18–22 mm",
    readinessTitle: "Disponibilidad de datos",
    readinessLine1: "NDVI · FAO-56 · Análisis de suelo: DISPONIBLE",
    readinessLine2: "Evaluación de alertas: PENDIENTE — informe parcial",
    recsTitle: "Recomendaciones agronómicas",
    recsLine1: "Inspeccionar sub-zona noreste por posible estrés hídrico",
    recsLine2: "Ejecutar evaluación de alertas para pasar a informe completo",
    disclaimerTitle: "Aviso profesional",
    disclaimerLine1: "Salida de apoyo a la decisión basada en Sentinel-2 y modelado FAO-56.",
    disclaimerLine2: "No reemplaza el asesoramiento agronómico profesional."
    ,
    footnote: "Ejemplo ilustrativo. Los informes reales utilizan adquisiciones Sentinel-2 reales y cálculos FAO-56 para la parcela seleccionada.",
    verificationNote: "Los informes incluyen un ID documental que puede comprobarse en /verify/report."
  },
  ndviShowcase: {
    badge: "Tecnología Satelital Sentinel-2",
    title: "Evidencia satelital por parcela",
    subtitle: "Las imágenes NDVI de Sentinel-2 exponen la variación por parcela como evidencia auditable — la capa objetiva detrás de cada Field Intelligence Report.",
    resolution: "Resolución",
    resolutionValue: "10m píxeles",
    updateFrequency: "Frecuencia",
    updateFrequencyValue: "Cada 5 días",
    accuracy: "Precisión",
    professionalTitle: "Monitoreo Satelital Profesional",
    professionalDesc: "Nuestra plataforma procesa datos de Sentinel-2 para generar mapas NDVI precisos. Las zonas verdes indican vegetación saludable, mientras que las áreas rojas/naranjas revelan estrés por sequía, enfermedades o deficiencia de nutrientes.",
    detectTitle: "Lo Que Puedes Detectar:",
    detectItems: ["Estrés hídrico antes del marchitamiento visible", "Deficiencias de nutrientes en zonas específicas", "Brotes de enfermedades en etapas tempranas", "Fallos en sistemas de riego"],
    liveLabel: "En vivo · Time-lapse Sentinel-2"
  },
  earlyAccess: {
    badge: "Ya Disponible",
    title: "Solicita acceso piloto a la capa de evidencia",
    subtitle: "Incorpora tu cooperativa, cartera u operación al stack de evidencia por parcela y reporting FAO-56 de Sentinel Crop.",
    algorithms: "Algoritmos",
    satelliteIndices: "Índices Satelitales",
    validatedAccuracy: "Precisión Validada",
    startTrial: "Solicitar acceso piloto",
    viewFeatures: "Ver Todas las Funciones",
    noCreditCard: "Plan gratuito disponible",
    realData: "Datos satelitales reales",
    discount: "50% descuento early adopter",
    trust: "Algoritmos validados con imágenes satelitales Sentinel-2 reales y datos meteorológicos globales."
  },
  advancedCapabilities: {
    badge: "Capacidades Avanzadas",
    title: "Más Allá del Monitoreo Básico",
    subtitle: "100+ módulos de producción potenciando funcionalidades que no encontrarás en ningún otro lugar",
    fire: { title: "Detección de Incendios", desc: "Alertas multi-fuente NASA FIRMS + EFFIS" },
    ml: { title: "Detección de Anomalías", desc: "Machine learning para riesgos agronómicos (Beta)" },
    phenology: { title: "Fenología y GDD", desc: "Seguimiento de grados día de crecimiento" },
    harvest: { title: "Estimador de Cosecha", desc: "Predicción agronómica de rendimiento v2.0" },
    vra: { title: "Mapas VRA", desc: "Zonas de fertilización de tasa variable" },
    rotation: { title: "Rotación con IA", desc: "Rotación inteligente con reglas de suelo" },
    passport: { title: "Pasaporte de Parcela", desc: "Trazabilidad y registros de cumplimiento de la explotación" },
    foliar: { title: "Análisis Foliar OCR", desc: "Escaneo y análisis de informes de laboratorio" }
  },
  roiCalculator: {
    badge: "Calculadora de Ahorro de Agua",
    title: "Estima el ahorro potencial de agua",
    subtitle: "Estima el ahorro potencial de agua y costes usando un motor FAO-56 ET₀ y supuestos conservadores de literatura. Cifras indicativas, no un retorno garantizado.",
    yourFarm: "Datos de Tu Finca",
    cropType: "Tipo de Cultivo",
    region: "Región",
    hectares: "Superficie",
    methodology: "Algoritmo FAO-56 ET₀ (R²=0.94 coherencia interna, n=472 obs, referencia Open-Meteo). Estimación conservadora del 20% de ahorro.",
    yourSavings: "Tu Ahorro Estimado",
    savedPerYear: "ahorrados por año",
    cubicMetersSaved: "m³ agua ahorrados/año",
    kgCO2Avoided: "kg CO₂ evitados/año",
    roiLabel: "Retorno estimado frente al coste del plan:",
    roiDescription: "{{roi}}% de retorno sobre inversión de €588/año",
    cta: "Explorar la plataforma",
    disclaimer: "Estimación indicativa basada en literatura genérica FAO-56. El ahorro real depende de cada explotación y no ha sido medido de forma independiente por Sentinel Crop. No es un retorno garantizado."
  },
  idealCustomer: {
    badge: "Para quién es",
    title: "¿Para quién es Sentinel Crop?",
    subtitle: "Distintos equipos necesitan distinta evidencia. Sentinel Crop ayuda a productores, cooperativas, aseguradoras y asesores a convertir datos de parcela en informes de apoyo a la decisión.",
    farms: {
      title: "Productores y cooperativas",
      headline: "Informes que ayudan a explicar por qué se tomó una decisión agronómica.",
      body: "Documenta decisiones de riego, fertilización, scouting y apoyo a tratamiento con evidencia satelital, meteorológica y de campo.",
      useCases: ["Revisión de riego", "Planificación de fertilización", "Priorización de scouting", "Reportes para socios"],
      cta: "Explorar piloto"
    },
    insurers: {
      title: "Aseguradoras agrícolas",
      headline: "Informes que ayudan a documentar condiciones de parcela tras un siniestro agrícola asegurado.",
      body: "Revisa timestamps satelitales, anomalías de lluvia, tendencias NDVI/NDWI, registros de campo y limitaciones de datos como evidencia de apoyo para la revisión de siniestros.",
      useCases: ["Revisión post-evento", "Evidencia antes / después", "Triaje remoto de siniestros", "Documentación de apoyo"],
      disclaimer: "Evidencia de apoyo a decisión. No es una valoración oficial de pérdida.",
      cta: "Analizar caso de revisión de siniestros"
    },
    advisors: {
      title: "Asesores agronómicos",
      headline: "Informes de apoyo a decisión que convierten señales de parcela en próximos pasos claros.",
      body: "Prioriza qué parcelas necesitan revisión de riego, ajuste de fertilización, scouting o validación de campo dirigida.",
      useCases: ["Recomendaciones técnicas", "Priorización de visitas de campo", "Revisión de apoyo a tratamiento", "Informes para clientes"],
      cta: "Hablar con ventas"
    }
  },
  problem: {
    badge: "El problema",
    title: "Las decisiones agrícolas siguen necesitando más evidencia.",
    subtitle: "Las cooperativas a menudo necesitan evidencia más sólida detrás de las condiciones reportadas por sus miembros. Las aseguradoras necesitan formas más rápidas de revisar las condiciones de una parcela después de un evento agrícola. Los productores todavía toman decisiones de riego con datos incompletos sobre demanda hídrica.",
    items: [
      {
        metric: "$1.25B",
        label: "tamaño de mercado estimado para la verificación de siniestros vía satélite — estimación sectorial de terceros, solo indicativa.",
        source: "Estimación sectorial, 2025 — cifra indicativa"
      },
      {
        metric: "44%",
        label: "del agua de riego extraída a nivel global se estima que supera la necesidad real del cultivo, según referencias de la FAO sobre uso de agua de riego.",
        source: "Referencias FAO AQUASTAT sobre uso de agua de riego"
      },
      {
        metric: "60%",
        label: "de los terrenos irrigados globales se estima que operan bajo alto estrés hídrico, según referencias de la FAO sobre riego sostenible.",
        source: "Referencias FAO sobre riego sostenible"
      }
    ],
    sourcesFootnote: "Fuentes: referencias FAO AQUASTAT · referencias FAO sobre riego sostenible · estimaciones sectoriales. Cifras indicativas, aportadas solo como contexto."
    ,
    painPointsTitle: "Cómo se ve esto en el campo",
    painPoints: [
      { title: "Condiciones reportadas por socios", desc: "Las cooperativas suelen necesitar evidencia satelital o de campo adicional para respaldar las declaraciones de sus socios." },
      { title: "Revisión post-evento de parcelas", desc: "Las aseguradoras se benefician de formas más rápidas de revisar condiciones de parcela tras un evento agrícola." },
      { title: "Datos hídricos incompletos", desc: "Los productores todavía programan riegos con poco contexto de ET₀ o humedad de suelo por parcela." }
    ]
  },
  faq: {
    badge: "FAQ Enterprise",
    title: "Lo que los compradores preguntan antes de firmar.",
    subtitle: "Respuestas directas a las preguntas que cooperativas, aseguradoras y grandes productores plantean en su proceso de compra.",
    talkToSales: "Hablar con ventas",
    items: [
      {
        q: "¿Cómo se integra Sentinel Crop con nuestro ERP, GIS o sistema de siniestros?",
        a: "Exponemos una API REST documentada con endpoints a nivel parcela (NDVI, ET₀, estado hídrico, alertas, certificados) y exportaciones estándar (GeoJSON, Shapefile, CSV, PDF). Los webhooks y conectores directos a ERP / sistemas de siniestros están disponibles para pilotos Enterprise e implementación a medida, definidos por cliente."
      },
      {
        q: "¿Dónde se almacenan nuestros datos y cómo están protegidos?",
        a: "Datos en infraestructura cloud auditada (por defecto región UE; otras regiones bajo petición), cifrados en reposo y en tránsito. Row-level security por organización. Términos de procesamiento de datos orientados al RGPD disponibles para clientes Enterprise. Opcionalmente, anclaje de hashes de certificados seleccionados (sin datos personales) a un ledger público como sello temporal independiente — tus datos brutos nunca salen de nuestra infraestructura."
      },
      {
        q: "¿Cuánto dura el onboarding para una cooperativa con más de 200 socios?",
        a: "Plazo típico: 2 semanas para ingesta de parcelas (importación masiva KML, shapefile, GeoJSON o registros catastrales locales donde estén disponibles), 1 semana para alta de usuarios y configuración de roles, 1 semana para integración ERP. Producción completa en 4–6 semanas con customer success dedicado."
      },
      {
        q: "¿Puede la evidencia usarse en auditorías, peritajes o reporting al consejo?",
        a: "Los informes generados incluyen un ID documental SHA-256. Terceros pueden verificar si el ID fue emitido por Sentinel Crop y ver metadata no sensible como tipo de informe, fecha de generación, secciones incluidas y secciones faltantes declaradas. Los informes son evidencia de apoyo y no sustituyen decisiones oficiales de auditoría, legales, aseguradoras o de cumplimiento."
      },
      {
        q: "¿Cuál es el SLA y el modelo de soporte para clientes Enterprise?",
        a: "Account manager dedicado, revisiones periódicas de negocio y soporte agronómico para flujos de revisión de siniestros. Los compromisos de uptime, tiempos de respuesta y despliegue white-label están disponibles para pilotos Enterprise e implementación a medida, definidos contractualmente por cliente."
      },
      {
        q: "¿Cómo se estructura el precio para carteras de más de 10.000 hectáreas?",
        a: "Precio por volumen con coste decreciente por hectárea a partir de 5.000 ha. Los tiers de aseguradora y cooperativa incluyen usuarios ilimitados, acceso API e informes white-label. Contacta con ventas para una cotización a medida según tu cartera e integraciones."
      },
      {
        q: "¿Podemos hacer white-label de la plataforma para nuestros socios o asegurados?",
        a: "Sí, en plan Enterprise. Dominio propio, tu logo y paleta, tus términos de servicio. Dashboard para socios/asegurados con scope restringido. Nosotros operamos técnicamente entre bastidores."
      },
      {
        q: "¿Qué pasa con nuestros datos históricos si nos vamos?",
        a: "Exportación completa de datos a petición: mediciones brutas, certificados, informes en formatos abiertos (GeoJSON, CSV, PDF). Periodo de gracia de 90 días tras fin de contrato. Sin vendor lock-in por diseño — tus parcelas y tu historial son tuyos."
      }
    ]
  },
  builtOn: {
    badge: "Construido sobre",
    title: "Datos abiertos, infraestructura auditada",
    subtitle: "No reinventamos la rueda — nos apoyamos en programas públicos de observación de la Tierra, redes meteorológicas globales e infraestructura cloud auditada.",
    disclaimer: "Todos los nombres y marcas son propiedad de sus respectivos titulares. Sentinel Crop es una plataforma independiente y no está afiliada, respaldada ni patrocinada por ninguna de las organizaciones mencionadas.",
    sources: [
      { name: "Sentinel-1 / 2", category: "Imagen radar y óptica" },
      { name: "Landsat 8 / 9", category: "Multispectral global" },
      { name: "Reanálisis climático global", category: "Datos meteorológicos a largo plazo" },
      { name: "APIs de pronóstico multi-fuente", category: "Meteorología mundial" },
      { name: "Polygon PoS (opcional)", category: "Hashing de certificados con evidencia de manipulación — Acceso Anticipado" },
      { name: "PostgreSQL + PostGIS", category: "Backend geoespacial" },
      { name: "Procesamiento global de tarjetas", category: "Pagos PCI-DSS" },
      { name: "Pasarela de inferencia IA", category: "Capa de servicio de modelos" }
    ]
  },
  differentiators: {
    badge: "Diferenciadores técnicos",
    title: "Qué nos hace diferentes",
    subtitle: "Motores operativos y módulos en acceso anticipado construidos sobre ciencia agronómica, con capacidades en beta claramente etiquetadas. Los módulos clave incluyen notas transparentes de benchmark cuando están disponibles.",
    footnote: "Sentinel Crop combina satélite, meteorología y modelos agronómicos en un único flujo de trabajo.",
    items: [
      {
        title: "Predicción de Rendimiento ML (Beta)",
        tag: "Gemini 3 Flash + modelos deterministas",
        description: "Pronóstico híbrido de rendimiento que combina razonamiento LLM con modelos de regresión entrenados sobre FAOSTAT y rendimientos históricos regionales globales. Validación de campo en curso.",
        proof: "Respaldado por más de 30 años de datos de referencia globales"
      },
      {
        title: "Humedad de Suelo Sentinel-1 SAR",
        tag: "Backscatter VV/VH, datos reales",
        description: "Humedad del suelo derivada por radar que funciona a través de nubes, de día o de noche — no solo óptico como la mayoría de competidores.",
        proof: "Ingesta directa de Copernicus Sentinel-1"
      },
      {
        title: "FAO-56 Penman-Monteith ET₀",
        tag: "Evapotranspiración de referencia + Dual Kc (Beta)",
        description: "ET₀ FAO-56 Penman-Monteith completo con balance hídrico Dual Kc (Capítulo 7) que separa la evaporación del suelo de la transpiración de la planta. Dual Kc actualmente en validación Beta.",
        proof: "ET₀: R² = 0,9390, RMSE = 0,3266 mm/día · n=472 vs Open-Meteo (coherencia algorítmica interna)"
      },
      {
        title: "Zonificación sub-parcela K-Means++",
        tag: "Diseñado para cobertura completa de parcela",
        description: "Zonas de manejo de Tasa Variable con reasignación de píxeles residuales — cada metro cuadrado de la parcela queda clasificado.",
        proof: "Alimenta mapas de fertilización VRA y riego VRI"
      },
      {
        title: "Motor de Fenología GDD",
        tag: "Grados Día de Crecimiento, específico por cultivo",
        description: "Seguimiento fenológico científico con umbrales por etapa del cultivo — utilizado por predicción de heladas, modelos de plagas y pronóstico de cosecha.",
        proof: "Enfriamiento radiativo de Snyder + inversión térmica"
      },
      {
        title: "Verificación de Cultivo (4 fuentes)",
        tag: "Copernicus × NDVI × fenología × cobertura del suelo",
        description: "Cruza el cultivo declarado contra cuatro fuentes de datos independientes — cobertura satelital del suelo, perfil temporal NDVI, firma fenológica y referencias catastrales regionales — para detectar discrepancias antes de auditorías de subsidios o sostenibilidad.",
        proof: "Sin región fija: funciona en Europa, América, África y Asia"
      },
      {
        title: "Monitorización IoT en Tiempo Real",
        tag: "Supabase Realtime (postgres_changes)",
        description: "Actualizaciones de sensores en vivo sin recarga manual — sondas de suelo, estaciones meteorológicas y controladores de riego transmiten al dashboard.",
        proof: "Actualizaciones en tiempo real vía Supabase Realtime"
      }
    ]
  },
  roadmap: {
    badge: "Roadmap y Acceso Anticipado",
    title: "Módulos en desarrollo activo.",
    subtitle: "Estos motores forman parte de la plataforma pero todavía se están validando contra datos de campo y benchmarks externos. Los etiquetamos con honestidad para que sepas qué es production-grade y qué es una versión temprana.",
    footnote: "El acceso para design partners se concede caso por caso. Los módulos del roadmap no forman parte del precio estándar y no son un sustituto de seguros licenciados, productos financieros regulados o servicios oficiales de emergencias.",
    statusEarlyAccess: "Acceso Anticipado",
    statusBeta: "Beta",
    statusRoadmap: "Roadmap",
    statusDataDependent: "Dependiente de datos",
    items: [
      {
        title: "Trazabilidad documental verificable",
        status: "earlyAccess",
        description: "Los informes generados incluyen un ID documental SHA-256 que puede comprobarse en la página pública de verificación de Sentinel Crop. El anclaje público opcional aplica solo a certificados seleccionados, no a todos los informes."
      },
      {
        title: "Estimación de carbono basada en actividades",
        status: "dataDependent",
        description: "Estima emisiones a partir de actividades registradas en campo usando factores de emisión basados en literatura. Los indicadores satelitales de vegetación pueden aportar contexto, pero no es una estimación verificada de stock de carbono ni un crédito de carbono certificado."
      },
      {
        title: "Módulos de seguro paramétrico",
        status: "earlyAccess",
        description: "Modelado de escenarios para disparadores de sequía, helada y exceso de lluvia, pensado para evaluación con design partners. No es un producto de seguro licenciado ni un motor de pagos."
      },
      {
        title: "Simulación de propagación de incendios",
        status: "beta",
        description: "Modelo de propagación basado en Rothermel con conjunto Monte-Carlo opcional para márgenes de incertidumbre. Comparado con casos de referencia USDA; validación de campo en curso. Trata las salidas como apoyo a la decisión, no como sustituto de protección civil."
      },
      {
        title: "Scoring de crédito agrícola",
        status: "roadmap",
        description: "Scoring de riesgo a nivel parcela que combina histórico de rendimiento, estabilidad de NDVI y patrones de estrés hídrico — pensado para entidades de crédito agro y financiación de insumos. Elemento del roadmap; estamos hablando con design partners iniciales."
      },
      {
        title: "Packs de informes de subsidios y cumplimiento",
        status: "beta",
        description: "Packs de informes preformateados para auditorías de subsidios, trazabilidad y sostenibilidad, además de estándares voluntarios. La cobertura de formatos crece según solicitudes de cooperativas y clientes agro."
      }
    ]
  },
  pwaInstall: {
    title: "Instalar Sentinel Crop",
    description: "Instala nuestra app para acceso rápido y funcionalidad sin conexión",
    install: "Instalar",
    notNow: "Ahora no",
    close: "Cerrar"
  },
  meetGaucho: {
    badge: "Conoce a Gaucho",
    title: "Conoce a Gaucho",
    subtitle: "Tu asistente supervisado de operaciones agrícolas.",
    body: "Gaucho conecta datos satelitales, contexto del cultivo, observaciones de campo y recomendaciones basadas en evidencia para ayudarte a entender qué requiere atención.",
    bullets: [
      "Convierte datos de parcela en prioridades operativas.",
      "Muestra qué evidencia falta antes de emitir recomendaciones más fuertes.",
      "Mantiene las decisiones sensibles en revisión.",
      "Construye un plan de acción supervisado sin ejecutar operaciones en campo."
    ],
    safetyLine: "Gaucho apoya la toma de decisiones. No reemplaza una revisión agronómica cualificada ni ejecuta acciones en campo.",
    avatarAlt: "Avatar del asistente supervisado Gaucho"
  },
  futureRoadmap: {
    badge: "Roadmap a largo plazo",
    title: "Roadmap: de la inteligencia agronómica a la producción verificada",
    subtitle: "La visión a largo plazo de SentinelCrop es convertir la evidencia agronómica en confianza comercial: primero agronomía, después procedencia de la evidencia y más adelante aprovisionamiento respaldado por evidencia. La prioridad técnica actual sigue siendo la inteligencia agronómica; el marketplace no es una prioridad inmediata de ingeniería.",
    futureBadge: "Roadmap futuro — no es una función activa",
    currentPriorityTitle: "Prioridad técnica actual",
    currentPriority: "Inteligencia agronómica: evidencia satelital / meteorológica / de campo → gestión hídrica FAO-56 → razonamiento operativo supervisado de Gaucho → informes condicionados por evidencia.",
    priorityTitle: "Secuencia a corto plazo (sin fechas comprometidas)",
    priorityOrder: [
      "Integridad de la decisión FAO-56 / riego",
      "Trabajo canónico de objetivo de aplicación de riego",
      "Integración de Gaucho y razonamiento agronómico más amplio",
      "Validación prospectiva real en campo cuando haya una parcela instrumentada",
      "Pasaporte de Evidencia / procedencia de la producción",
      "Lote de Producción Verificada",
      "Red privada de compradores",
      "Marketplace",
      "Servicios financieros"
    ],
    stages: [
      {
        title: "Etapa 1 — Inteligencia agronómica",
        description: "Evidencia satelital, meteorológica y de campo, gestión hídrica FAO-56, el asistente supervisado Gaucho, detección de riesgos, prioridades operativas, decisiones condicionadas por evidencia e informes defendibles. Estado: desarrollo actual / activo.",
        futureOnly: false
      },
      {
        title: "Etapa 2 — Capa de confianza y evidencia",
        description: "Pasaporte de Evidencia de parcela / campaña, evidencia de cosecha, evidencia de calidad y laboratorio, procedencia de la producción, el concepto de Lote de Producción Verificada, hashes a prueba de manipulación y anclaje público opcional cuando sea apropiado. El anclaje prueba la integridad del registro; no prueba por sí solo la existencia física de la mercancía. Estado: roadmap futuro.",
        futureOnly: true
      },
      {
        title: "Etapa 3 — Red de aprovisionamiento verificado",
        description: "Primero una red privada de compradores: productores y cooperativas ponen a disposición lotes de producción respaldados por evidencia, y compradores autorizados buscan, filtran y emparejan producción por cultivo, origen, cantidad, calidad, cosecha y estado de procedencia / evidencia, con solicitudes, matching, requisitos del comprador y un flujo comercial trazable. No es un marketplace operativo. Estado: roadmap futuro.",
        futureOnly: true
      },
      {
        title: "Etapa 4 — Marketplace de producción verificada",
        description: "Un posible marketplace futuro multi-comprador / multi-vendedor basado en producción respaldada por evidencia: listados de producción verificada, filtros de calidad y procedencia, flujo comprador / vendedor e integraciones potenciales de logística, transacción o liquidación. Los pagos y la liquidación no están implementados, y cualquier medio de liquidación —incluidas opciones de stablecoin o escrow— sería una integración de terceros no comprometida. Estado: roadmap futuro.",
        futureOnly: true
      },
      {
        title: "Etapa 5 — Servicios financieros",
        description: "Integraciones futuras potenciales con socios licenciados para apoyo a seguros agrarios, financiación de cultivo / inventario, pre-financiación, financiación comercial y factoring / adelantos. SentinelCrop no ofrece actualmente productos financieros regulados. Estado: roadmap futuro.",
        futureOnly: true
      }
    ]
  }
};
